import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../components/Popup";
import { CvvPrepareGate } from "../../components/CvvPrepareGate";
import { DEFERRED_ORIGINATION_ROUTES } from "../../constants";
import { deferredOriginationSavedCards } from "../../gallery/deferredOriginationMock";
import { RecipientPage } from "./RecipientPage";

/**
 * Gallery inspectable state: Recipient with the funding CVV prepare popup open.
 */
export const CvvPrepareGatePage = memo(() => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const card = deferredOriginationSavedCards[0];

  return (
    <>
      <RecipientPage />
      <Popup
        visible={visible}
        onClose={() => {
          setVisible(false);
          navigate(DEFERRED_ORIGINATION_ROUTES.RECIPIENT);
        }}
      >
        <CvvPrepareGate
          ns="deferred-origination"
          last4={card.last4}
          brand={card.brand}
          onClose={() => {
            setVisible(false);
            navigate(DEFERRED_ORIGINATION_ROUTES.RECIPIENT);
          }}
          onSubmit={() => {
            navigate(DEFERRED_ORIGINATION_ROUTES.MINTING, { replace: true });
          }}
        />
      </Popup>
    </>
  );
});
